module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sort.selected),
      expression: "sort.selected"
    }],
    staticClass: "form-control auto-width",
    staticStyle: {
      "margin-bottom": "30px"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sort.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeSort]
    }
  }, _vm._l((_vm.sort.items), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n        " + _vm._s(option.label) + "\n      ")])
  })), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query.kerkif),
      expression: "query.kerkif"
    }],
    staticClass: "form-control auto-width",
    attrs: {
      "placeholder": "Keresés...",
      "id": "kereso"
    },
    domProps: {
      "value": (_vm.query.kerkif)
    },
    on: {
      "keyup": _vm.changeSerach,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query.kerkif = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "competition-items"
  }, _vm._l((_vm.forms), function(form, i) {
    return _c('div', {
      staticClass: "competition-item-outer"
    }, [_c('div', {
      staticClass: "competition-item"
    }, [_c('div', [_c('i', {
      staticClass: "fa fa-file-o"
    }), _vm._v("\n              " + _vm._s(form.name) + "\n            "), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(form.subname))]), _vm._v(" "), _c('router-link', {
      staticClass: "button",
      attrs: {
        "to": {
          path: '/palyazatra_jelentkezes/?id=' + form.id
        }
      }
    }, [_vm._v("Jelentkezem")])], 1)])])
  })), _vm._v(" "), _c('div', {
    staticClass: "breadcrumbs clearfix"
  }, [_c('div', {
    staticClass: "result"
  }, [_vm._v("\n        Összesen "), _c('span', [_vm._v(_vm._s(_vm.pcs))]), _vm._v(" találat.\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57ee9c46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/organization.vue
// module id = 373
// module chunks = 0